import React from 'react';

import { BrandColor } from '@styleseat/brand';
import {
  BodyText,
  Stack,
  Separator,
} from '../../ui';
import TrackedOption from './TrackedOption';
import { SecretTouchable } from '../developer/SecretTouchable';

interface SidebarStyleSeatSectionProps {
  displayDeveloperMenu: () => void;
  goToExternalPage: (url: string, target?: string) => void;
  openTerms: () => void;
  openPrivacy: () => void;
  openHelpCenter: () => void;
}

const SidebarStyleSeatSection: React.FC<SidebarStyleSeatSectionProps> = ({
  displayDeveloperMenu,
  goToExternalPage,
  openTerms,
  openPrivacy,
  openHelpCenter,
}) => (
  <Stack padding={20} space={4}>
    <SecretTouchable
      onSecretClick={displayDeveloperMenu}
      onClick={() => {}}
    >
      <BodyText appearance="large" weight="bold">
        StyleSeat
      </BodyText>
    </SecretTouchable>
    <Separator color={BrandColor.LightGrey} appearance="extrathin" paddingTop={20} />
    <TrackedOption
      name="sidebar-blog-clicked"
      testID="sidebar-blog-menu"
      onPress={() => goToExternalPage('blog')}
    >
      <BodyText>Blog</BodyText>
    </TrackedOption>
    <Separator color={BrandColor.LightGrey} appearance="extrathin" paddingTop={20} />
    <TrackedOption
      name="sidebar-help-center-clicked"
      testID="sidebar-help-center-menu"
      onPress={openHelpCenter}
    >
      <BodyText>Help Center</BodyText>
    </TrackedOption>
    <Separator color={BrandColor.LightGrey} appearance="extrathin" paddingTop={20} />
    <TrackedOption
      name="sidebar-careers-clicked"
      testID="sidebar-careers-menu"
      onPress={() => goToExternalPage('careers')}
    >
      <BodyText>Careers</BodyText>
    </TrackedOption>
    <Separator color={BrandColor.LightGrey} appearance="extrathin" paddingTop={20} />
    <TrackedOption
      name="sidebar-terms-of-service-clicked"
      testID="sidebar-terms-of-service-menu"
      onPress={openTerms}
    >
      <BodyText>Terms of service for Pros</BodyText>
    </TrackedOption>
    <Separator color={BrandColor.LightGrey} appearance="extrathin" paddingTop={20} />
    <TrackedOption
      name="sidebar-privacy-clicked"
      testID="sidebar-privacy-menu"
      onPress={openPrivacy}
    >
      <BodyText>Privacy</BodyText>
    </TrackedOption>
    <Separator color={BrandColor.LightGrey} appearance="extrathin" paddingTop={20} />
    <TrackedOption
      name="sidebar-sitemap-clicked"
      testID="sidebar-sitemap-menu"
      onPress={() => goToExternalPage('sitemap')}
    >
      <BodyText>Sitemap</BodyText>
    </TrackedOption>
    <Separator color={BrandColor.LightGrey} appearance="extrathin" paddingTop={20} />
  </Stack>
);

export default SidebarStyleSeatSection;
